/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { PolygonProps } from '../utils/UNSAFE_visTypes/common';

const STAR_POLYGON_CMDS = [
  -50, -11.22, -16.69, -17.94, 0, -47.55, 16.69, -17.94, 50, -11.22, 26.69, 13.8, 30.9, 47.56, 0,
  33.42, -30.9, 47.56, -26.69, 13.8
];

export const Polygon = ({
  type,
  scaleX,
  scaleY,
  tx,
  ty,
  height,
  width,
  fill,
  stroke,
  strokeWidth = 1,
  dataInfo,
  isInteractive
}: PolygonProps) => {
  let cmds: number[];
  const cx = 0;
  const cy = 0;
  const s = Math.min(width, height);
  let sX = scaleX;
  let sY = scaleY;
  const half = s / 2;
  const sixth = s / 6;

  switch (type) {
    case 'star': {
      sX = sX * (width / 100);
      sY = sY * (height / 100);
      cmds = STAR_POLYGON_CMDS;
      break;
    }
    case 'triangleUp': {
      cmds = [cx - half, cy + half, cx, cy - half, cx + half, cy + half];
      break;
    }
    case 'triangleDown': {
      cmds = [cx - half, cy - half, cx, cy + half, cx + half, cy - half];
      break;
    }
    case 'diamond': {
      cmds = [cx - half, cy, cx, cy - half, cx + half, cy, cx, cy + half];
      break;
    }
    case 'plus': {
      cmds = [
        cx - half,
        cy - sixth,
        cx - sixth,
        cy - sixth,
        cx - sixth,
        cy - half,
        cx + sixth,
        cy - half,
        cx + sixth,
        cy - sixth,
        cx + half,
        cy - sixth,
        cx + half,
        cy + sixth,
        cx + sixth,
        cy + sixth,
        cx + sixth,
        cy + half,
        cx - sixth,
        cy + half,
        cx - sixth,
        cy + sixth,
        cx - half,
        cy + sixth
      ];
      break;
    }
    default:
      cmds = [];
  }
  return (
    <polygon
      {...dataInfo}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      cursor={isInteractive ? 'pointer' : undefined}
      vectorEffect="non-scaling-stroke"
      transform={`translate(${tx} ${ty}) scale(${sX} ${sY})`}
      points={cmds.join(' ')}
    />
  );
};
